import React, { useContext } from "react";
import { Link, Redirect, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export default function NavMenu() {
  const { isAuthenticated, userType, userDetails, userLogout } = useContext(
    AuthContext
  );
  const location = useLocation();

  const logout = async () => {
    await userLogout();
  };

  const isActive = (path) => {
    return location.pathname + location.search === path ? "active" : "";
  };

  const navMenus = () => {
    if (!isAuthenticated) {
      return (
        <React.Fragment>
          <li>
            <Link className={isActive("/job_search")} to={`/job_search`}>Search Jobs</Link>
          </li>
          {/* <li>
            <Link to={`/pages/career-service`}>Career Service</Link>
          </li> */}
          <li>
            <Link className={isActive("/blog")} to={`/blog`}>Blog</Link>
          </li>
          <li>
            <Link className={isActive("/training")} to={`/training`}>Training</Link>
          </li>
          <li>
            <Link className={isActive("/faq")} to={`/faq`}>Faq</Link>
          </li>
          <li>
            <Link className={isActive("/contact-us")} to={`/contact-us`}>Contact</Link>
          </li>
        </React.Fragment>
      );
    }

    if (userType == "seeker") {
      return (
        <React.Fragment>
          <li>
            <Link className={isActive("/job_search")} to={`/job_search`}>Search Jobs</Link>
          </li>
          <li>
            <Link className={isActive("/profile?tab=dashboard")} to="/profile?tab=dashboard">
              Dashboard
            </Link>
          </li>
          <li>
            <Link className={isActive("/profile?tab=myProfile")} to="/profile?tab=myProfile">My Profile</Link>
          </li>
          {/* <li>
            <Link to="/profile?tab=editProfile">Edit Profile</Link>
          </li> */}
          <li>
            <Link className={isActive("/profile?tab=appliedJobs")} to="/profile?tab=appliedJobs">Applied Jobs</Link>
          </li>
        </React.Fragment>
      );
    } else if (userType == "employer") {
      return (
        <React.Fragment>
          <li>
            <Link className={isActive("/profile?tab=dashboard")} to="/profile?tab=dashboard">Dashboard</Link>
          </li>
          <li>
            <Link className={isActive("/profile?tab=myProfile")} to="/profile?tab=myProfile">Company Profile</Link>
          </li>
          <li>
            <Link className={isActive("/profile?tab=editProfile")} to="/profile?tab=editProfile">Edit Profile</Link>
          </li>
          <li>
            <Link className={isActive("/profile?tab=postJob")} to="/profile?tab=postJob">Post A Job</Link>
          </li>
        </React.Fragment>
      );
    }
  };

  const rightMenu = () => {
    if (!isAuthenticated) {
      return (
        <div className="extra-nav header-2-nav">
          <div className="extra-cell">
            <div className="header-nav-btn-section">
              <div className="twm-nav-btn-left">
                <Link to={"/login-seeker"} className="twm-nav-post-a-job">
                  <i className="ri-briefcase-line"></i> Login
                </Link>
              </div>
              <div className="twm-nav-btn-right">
                <Link to={"/register-seeker"} className="twm-nav-sign-up">
                  <i className="ri-login-box-line"></i> Sign Up
                </Link>
              </div>
              <div className="custom-vertical-line"></div>
              <div className="nav-employer-zone">
                <Link to={"/employer-zone"}>
                   Employer Zone
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (userType == "seeker") {
      return (
        <div className="dropdown  text-end">
          <a
            href="#"
            className="d-flex align-items-center link-dark text-decoration-none dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {/* <img
              src="https://github.com/mdo.png"
              alt=""
              width="32"
              height="32"
              className="rounded-circle me-2"
            ></img> */}
            <strong>{userDetails.first_name || userDetails.username}</strong>
          </a>
          <ul className="dropdown-menu text-small shadow">
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=dashboard")}`} to="/profile?tab=dashboard">
                <i className="ri ri-dashboard-3-line"></i> Dashboard
              </Link>
            </li>
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=myProfile")}`} to="/profile?tab=myProfile">
                <i className="ri ri-profile-line"></i> My Profile
              </Link>
            </li>
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=editProfile")}`} to="/profile?tab=editProfile">
                <i className="ri ri-edit-2-line"></i> Edit Profile
              </Link>
            </li>
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=appliedJobs")}`} to="/profile?tab=appliedJobs">
                <i className="ri ri-suitcase-line"></i> Applied Job
              </Link>
            </li>
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=savedJobs")}`} to="/profile?tab=savedJobs">
                <i className="ri ri-save-line"></i> Saved Jobs
              </Link>
            </li>

            {/* <li>
              <Link className="dropdown-item" to="/profile?tab=cvDownload">
                <i className="ri ri-download-2-line"></i> CV Download
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/profile?tab=profileVisit">
                <i className="ri ri-user-follow-line"></i> Profile Visit
              </Link>
            </li> */}
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=changePassword")}`} to="/profile?tab=changePassword">
                <i className="ri ri-fingerprint-line"></i> Change Password
              </Link>
            </li>
            <li>
              <a className="dropdown-item" href="#" onClick={logout}>
                <i className="ri ri-logout-box-line"></i> Sign out
              </a>
            </li>
          </ul>
        </div>
      );
    } else if (userType == "employer") {
      return (
        <div className="dropdown  text-end">
          <a
            href="#"
            className="d-flex align-items-center link-dark text-decoration-none dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {/* <img
              src={userDetails.photo}
              alt={userDetails.comp_name}
              width="32"
              height="32"
              className="rounded-circle me-2"
            ></img> */}
            <strong>{userDetails.comp_name || userDetails.username}</strong>
          </a>
          <ul className="dropdown-menu text-small shadow">
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=dashboard")}`} to="/profile?tab=dashboard">
                <i className="ri ri-dashboard-3-line"></i> Dashboard
              </Link>
            </li>
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=myProfile")}`} to="/profile?tab=myProfile">
                <i className="ri ri-profile-line"></i> Company Profile
              </Link>
            </li>
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=editProfile")}`} to="/profile?tab=editProfile">
                <i className="ri ri-edit-2-line"></i> Edit Profile
              </Link>
            </li>
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=postJob")}`} to="/profile?tab=postJob">
                <i className="ri ri-save-line"></i> Post A Job
              </Link>
            </li>
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=manageJob")}`} to="/profile?tab=manageJob">
                <i className="ri ri-suitcase-line"></i> Manage Jobs
              </Link>
            </li>
            {/* <li>
              <Link className="dropdown-item" to="/profile?tab=resume">
                <i className="ri ri-download-2-line"></i> Resume
              </Link>
            </li> */}
            <li>
              <Link className={`dropdown-item ${isActive("/profile?tab=changePassword")}`} to="/profile?tab=changePassword">
                <i className="ri ri-fingerprint-line"></i> Change Password
              </Link>
            </li>
            <li>
              <a className="dropdown-item" href="#" onClick={logout}>
                <i className="ri ri-logout-box-line"></i> Sign out
              </a>
            </li>
          </ul>
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      <button
        id="mobile-side-drawer"
        data-target=".header-nav"
        data-toggle="collapse"
        type="button"
        className="navbar-toggler collapsed"
      >
        <span className="sr-only">Toggle navigation</span>
        <span className="icon-bar icon-bar-first"></span>
        <span className="icon-bar icon-bar-two"></span>
        <span className="icon-bar icon-bar-three"></span>
      </button>

      <div
        className={`nav-animation header-nav navbar-collapse collapse d-flex ${
          isAuthenticated ? "justify-content-end" : ""
        }`}
      >
        <ul className="nav navbar-nav">{navMenus()}</ul>
      </div>
      {rightMenu()}
    </React.Fragment>
  );
}
